var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coinflip-coin",style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
    '--size': (_vm.size + "px"),
    '--thickness': (_vm.thickness + "px"),
    '--faces': _vm.faces,
  })},[_c('v-img',{staticClass:"coin--side coin--heads",attrs:{"src":_vm.coin[0].image,"width":_vm.size,"transition":false,"aspect-ratio":"1","contain":""}}),_c('div',{staticClass:"coin--edge"},_vm._l((_vm.faces),function(i){return _c('div',{key:i,style:({ '--i': i, })})}),0),_c('v-img',{staticClass:"coin--side coin--tails",attrs:{"src":_vm.coin[1].image,"width":_vm.size,"transition":false,"aspect-ratio":"1","contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }